const WHATSAPP_URL =
  'https://wa.me/905301714669?text=Merhaba%20SARA%20KUYUMCULUK%2C%20%C3%B6zel%20bir%20tasar%C4%B1m%20talep%20etmek%20istiyorum.';

const pieces = [
  {
    title: 'İsim Kolye',
    subtitle: 'Kişiye özel isim',
    desc: 'Kendi adınız ya da sevdiğinizin ismi, altın harflerle.',
    img: 'https://readdy.ai/api/search-image?query=elegant%20custom%20gold%20name%20necklace%20with%20cursive%20script%20letters%20on%20pure%20black%20velvet%20background%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20warm%20golden%20light%2C%20high-end%20minimal%20styling%2C%20delicate%20thin%20chain%2C%20feminine%20elegance&width=600&height=600&seq=4&orientation=squarish',
  },
  {
    title: 'Harf Kolye',
    subtitle: 'İlk harfiniz',
    desc: 'Baş harfinizi taşıyan, anlamlı bir pendant.',
    img: 'https://readdy.ai/api/search-image?query=delicate%20gold%20initial%20letter%20pendant%20necklace%20on%20black%20velvet%20display%20background%2C%20luxury%20jewelry%20photography%2C%20single%20capital%20letter%20charm%2C%20soft%20golden%20bokeh%20light%2C%20premium%20minimal%20product%20shot%2C%20feminine%20detail&width=600&height=600&seq=5&orientation=squarish',
  },
  {
    title: 'Bileklik',
    subtitle: 'Zarif zincir',
    desc: 'Her güne eşlik edecek, kişiye özel bileklik tasarımları.',
    img: 'https://readdy.ai/api/search-image?query=luxury%20custom%20gold%20chain%20bracelet%20on%20dark%20black%20velvet%20background%2C%20close-up%20macro%20product%20photography%2C%20soft%20golden%20ambient%20light%2C%20delicate%20linked%20chain%20pattern%2C%20premium%20minimal%20jewelry%20styling%2C%20feminine%20elegance&width=600&height=600&seq=6&orientation=squarish',
  },
  {
    title: 'Yüzük',
    subtitle: 'Özel tasarım',
    desc: 'Anlam yüklü, sade ve şık yüzük tasarımları.',
    img: 'https://readdy.ai/api/search-image?query=elegant%20custom%20gold%20ring%20with%20delicate%20minimal%20design%20on%20black%20reflective%20surface%20background%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20warm%20golden%20light%2C%20high-end%20minimal%20styling%2C%20feminine%20sophisticated%20atmosphere&width=600&height=600&seq=7&orientation=squarish',
  },
];

export default function InspirationSection() {
  return (
    <section id="inspiration" className="w-full bg-luxury-black py-24 md:py-36 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="reveal">
            <span className="font-sans text-gold text-xs tracking-luxury uppercase">
              İlham Galerisi
            </span>
          </div>
          <h2 className="reveal reveal-delay-1 font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light mt-5 leading-tight">
            Tasarım <em className="text-gold-gradient not-italic">İlhamı</em>
          </h2>
          <p className="reveal reveal-delay-2 font-sans text-white/40 text-xs mt-4 tracking-wide">
            * Bu görseller ilham amaçlıdır. Tüm tasarımlar kişiye özel üretilir.
          </p>
          <div className="reveal reveal-delay-3 gold-line w-24 mx-auto mt-6" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-14">
          {pieces.map((piece, i) => (
            <div
              key={piece.title}
              className={`reveal reveal-delay-${i + 1} group relative overflow-hidden luxury-border hover:border-gold/50 transition-all duration-500 cursor-pointer`}
            >
              {/* Image */}
              <div className="relative w-full h-64 md:h-72 overflow-hidden">
                <img
                  src={piece.img}
                  alt={piece.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-black via-transparent to-transparent" />
              </div>

              {/* Content */}
              <div className="bg-luxury-card p-5">
                <span className="font-sans text-gold text-xs tracking-luxury uppercase">
                  {piece.subtitle}
                </span>
                <h3 className="font-serif text-xl text-white mt-1 mb-2">{piece.title}</h3>
                <p className="font-sans text-white/40 text-xs leading-relaxed">{piece.desc}</p>
              </div>

              {/* Hover CTA */}
              <div className="absolute inset-0 flex items-center justify-center bg-luxury-black/80 opacity-0 group-hover:opacity-100 transition-opacity duration-400">
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="btn-gold px-6 py-3 text-xs rounded-sm whitespace-nowrap"
                  onClick={(e) => e.stopPropagation()}
                >
                  Bu Modeli İste
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
